import React from "react";
import { UserCircleIcon, BuildingOfficeIcon } from "@heroicons/react/24/outline";
import classNames from "../../../utils/classNames";

type Props = {
  type: string, selected?: boolean, disabled?: boolean, onClick: any,
};

const TypeSelect = ({
  selected = false, type, disabled = false, onClick,
}: Props) => (
  <button 
    type="button" 
    onClick={() => { if (!disabled) { onClick(type); } }} 
    className={classNames(
      "px-5 border ease-linear duration-200 rounded-xl py-3 flex items-center justify-between w-full transition-all", 
      selected ? "border-purple-500 bg-purple-50 shadow-sm" : "border-gray-200 hover:border-purple-200 hover:bg-gray-50", 
      disabled && "opacity-60 cursor-default hover:border-gray-200 hover:bg-gray-100"
    )}
  >
    <div className="flex text-gray-500 gap-4 items-center">
      {type === "accounts" ? (
        <div className="flex items-center justify-center h-10 w-10 bg-blue-50 rounded-lg text-blue-600">
          <BuildingOfficeIcon className="h-6 w-6" />
        </div>
      ) : (
        <div className="flex items-center justify-center h-10 w-10 bg-green-50 rounded-lg text-green-600">
          <UserCircleIcon className="h-6 w-6" />
        </div>
      )}
      <div className="flex flex-col justify-center text-left">
        <h3 className="capitalize text-gray-800 font-semibold text-md">{type}</h3>
        <p className="font-normal text-gray-500 text-sm">
          {type === "accounts" ? "Group of Users" : "People using your product"}
        </p>
      </div>
    </div>
    {selected && (
      <div className="flex items-center justify-center h-5 w-5 bg-purple-500 rounded-full">
        <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 3.5L4 6.5L9 1.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
    )}
  </button>
);

export default TypeSelect;
